import { jsx } from "react/jsx-runtime";
import { FluentProvider } from "@fluentui/react-components";
import { useMemo } from "react";
import { getTheme } from "./themes.js";
function BatiFlowThemeProvider({ theme, dir, children }) {
  const fluentTheme = useMemo(() => getTheme(theme, dir), [theme, dir]);
  return /* @__PURE__ */ jsx(FluentProvider, { theme: fluentTheme, dir, applyStylesToPortals: true, children });
}
export {
  BatiFlowThemeProvider
};
//# sourceMappingURL=theme-provider.js.map